import React from 'react';
import './Gallery.css';
import pioneer from '../../img/pioneer.jpg';
import pioneer0 from '../../img/pioneer0.jpg';
import pioneer1 from '../../img/pioneer1.jpg';

class pioneerg extends React.Component {
    state = {
        slides: [pioneer, pioneer0, pioneer1],
        image: 1
    }

    galleryControl(n) {
        let t = this.state.image;
        let l = this.state.slides.length;

        if(n + t >= l) {
            t = 0;
        } else if(n + t < 0) {
            t = l-1;
        } else {
            t = t + n;
        }

        this.setState({image: t});
    }

    render() {
        return (
            <div className="gallery">
                <img alt="ss1" src={this.state.slides[this.state.image]} className="gallery__slide"/>
                <div className="gallery__controls">
                    <button className="gallery__button inverted " onClick={() => {this.galleryControl(-1)}}>&#8249; Prev</button>
                    <a href="https://www.outdoorsy.com/rv-rental/franklin_tn/2019_heartland_pioneer_103282-listing?ref=bgo7j3"><button className="gallery__button">Book Me</button></a>
                    <button className="gallery__button inverted " onClick={() => {this.galleryControl(1)}}>Next &#8250;</button>
                </div>
                <p className="">BUNK-HOUSE Travel Trailer, 21ft, sleeps up to 5 (Delivery Available!)</p>
                <p className="">Be one of the first families to stay in our Brand New Camper! With a dry weight of 3,148lbs, this camper trailer can be pulled by most trucks and SUV’s. Or we can Deliver and have it set up for you! This RV comes fully equipped with sheets, blankets, pillows, towels, outdoor camp chairs, and more!</p>
                <p className=""><b>What's included?</b></p>
                <ul className="">
                    <li>Trash-can</li>
                    <li>Dish Strainer</li>
                    <li>Broom</li>
                    <li>All Linens (Sheets, Comforters, Pillows, Throw Blankets)</li>
                    <li>Towels</li>
                    <li>Hand Towels</li>
                    <li>Wash Clothes</li>
                    <li>Coffee Maker</li>
                    <li>Space Heater</li>
                    <li>Grilling Utensil Set</li>
                    <li>Outdoor Camp Chairs</li>
                    <li>Outdoor Rug & Door Mat</li>
                    <li>Cooking utensils, silver-ware, plates, cups, can openers, wine bottle opener, pots/pans, etc.</li>
                    <li>Bluetooth Stereo System</li>
                </ul>
                <p className="">Cheers and Happy Camping!</p>
            </div>
        );
    }
}

export default pioneerg;